<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Number format for this field']"
    >
    <mat-icon fontIcon="123"></mat-icon>
    <h3>
      Format number field
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>Thousands separator styles</p></td>
      </tr>
      <tr class="button-toggle-grid">
        <td>
          <mat-button-toggle-group
            name="thousandsStyle"
            aria-label="Decimal style"
            [(ngModel)]="thousandsSeparator"
            (change)="updateConfig()"
            [hideSingleSelectionIndicator]="true"
            >
            <mat-button-toggle [value]="NumberFormatSeparator.POINT">1.000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.COMMA">1,000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.NONE">1000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.WHITESPACE">1 000</mat-button-toggle>
          </mat-button-toggle-group>
        </td>
      </tr>
      <tr class="grey">
        <td>
          e.g. UK/US style: 1,000,000.00
          <br />European style: 1.000.000,00
        </td>
      </tr>
    </table>
  }
</section>
